// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.selectedTemplatesCardContent {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    padding: 20px;
    height: 35em;
    overflow: hidden;
    background-color: var(--templatesColorBackgroundContainer);
    border-radius: 2em;
    box-sizing: border-box;
    min-width: 400px;
    max-width: 400px;
}

.selectedTemplatesCardContent > * {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    overflow: hidden;
}

.selectedTemplatesCardImageLoaderInputValues {
    padding-bottom: 1em;
}

.selectedTemplatesCardContainerRemove {
    display: none;
}

.selectedTemplatesCardContentHead {
    display: flex;
    flex-direction: row-reverse;
    max-height: 2.5em;
    /* border: 1px solid green; */
    overflow: hidden;
}

.selectedTemplatesCardContentHeadContainer {
    display: block;
}

.selectedTemplatesCardTitle {
    margin-right: auto;
    font-weight: 800;
    font-size: 12px;
}

.selectedTemplatesCardImageBackButton {
    margin-left: auto;
}

.selectedTemplatesCardImageLoaderLicenseText {
    border: 2px dotted var(--GrayBlue);
    border-radius: 5px;
    font-size: 12px;
    width: 20em;
    text-align: center;
}

.selectedTemplatesCardImageLoaderEditContent {
    border: 2px dotted var(--GrayBlue);
    border-radius: 5px;
    font-size: 12px;
    width: 20em;
    text-align: center;
    padding-bottom: 1.5em;
}

.selectedTemplatesCardLine {
    max-height: 0px;
    width: 100%;
    border: 1px solid var(--GrayBlue);
}

.selectedTemplatesCardLineContainer {
    display: inline-flex;
    max-height: 2px;
    width: 100%;
}

.selectedTemplatesCardLoadingDisplay {
    display: flex;
    margin-left: auto;
    margin-right: auto;
    max-width: 20em;
}

.selectedTemplatesCardImageAndTitle {
    height: 15em;
    max-height: 15em;
}

.selectedTemplatesCardImageDisplay {
    display: inline-block;
    max-height: 15em;
    max-width: 20em;
    margin-left: auto;
    margin-right: auto;
    border-radius: 5px;
}
`, "",{"version":3,"sources":["webpack://./src/components/Dashboard/Templates/Selected/selectedImagesCardDisplay/selectedImagesCardDisplay.css"],"names":[],"mappings":"AAAA;IACI,aAAa;IACb,sBAAsB;IACtB,8BAA8B;IAC9B,aAAa;IACb,YAAY;IACZ,gBAAgB;IAChB,0DAA0D;IAC1D,kBAAkB;IAClB,sBAAsB;IACtB,gBAAgB;IAChB,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,gBAAgB;AACpB;;AAEA;IACI,mBAAmB;AACvB;;AAEA;IACI,aAAa;AACjB;;AAEA;IACI,aAAa;IACb,2BAA2B;IAC3B,iBAAiB;IACjB,6BAA6B;IAC7B,gBAAgB;AACpB;;AAEA;IACI,cAAc;AAClB;;AAEA;IACI,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;AACnB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,kBAAkB;AACtB;;AAEA;IACI,kCAAkC;IAClC,kBAAkB;IAClB,eAAe;IACf,WAAW;IACX,kBAAkB;IAClB,qBAAqB;AACzB;;AAEA;IACI,eAAe;IACf,WAAW;IACX,iCAAiC;AACrC;;AAEA;IACI,oBAAoB;IACpB,eAAe;IACf,WAAW;AACf;;AAEA;IACI,aAAa;IACb,iBAAiB;IACjB,kBAAkB;IAClB,eAAe;AACnB;;AAEA;IACI,YAAY;IACZ,gBAAgB;AACpB;;AAEA;IACI,qBAAqB;IACrB,gBAAgB;IAChB,eAAe;IACf,iBAAiB;IACjB,kBAAkB;IAClB,kBAAkB;AACtB","sourcesContent":[".selectedTemplatesCardContent {\n    display: flex;\n    flex-direction: column;\n    justify-content: space-between;\n    padding: 20px;\n    height: 35em;\n    overflow: hidden;\n    background-color: var(--templatesColorBackgroundContainer);\n    border-radius: 2em;\n    box-sizing: border-box;\n    min-width: 400px;\n    max-width: 400px;\n}\n\n.selectedTemplatesCardContent > * {\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    overflow: hidden;\n}\n\n.selectedTemplatesCardImageLoaderInputValues {\n    padding-bottom: 1em;\n}\n\n.selectedTemplatesCardContainerRemove {\n    display: none;\n}\n\n.selectedTemplatesCardContentHead {\n    display: flex;\n    flex-direction: row-reverse;\n    max-height: 2.5em;\n    /* border: 1px solid green; */\n    overflow: hidden;\n}\n\n.selectedTemplatesCardContentHeadContainer {\n    display: block;\n}\n\n.selectedTemplatesCardTitle {\n    margin-right: auto;\n    font-weight: 800;\n    font-size: 12px;\n}\n\n.selectedTemplatesCardImageBackButton {\n    margin-left: auto;\n}\n\n.selectedTemplatesCardImageLoaderLicenseText {\n    border: 2px dotted var(--GrayBlue);\n    border-radius: 5px;\n    font-size: 12px;\n    width: 20em;\n    text-align: center;\n}\n\n.selectedTemplatesCardImageLoaderEditContent {\n    border: 2px dotted var(--GrayBlue);\n    border-radius: 5px;\n    font-size: 12px;\n    width: 20em;\n    text-align: center;\n    padding-bottom: 1.5em;\n}\n\n.selectedTemplatesCardLine {\n    max-height: 0px;\n    width: 100%;\n    border: 1px solid var(--GrayBlue);\n}\n\n.selectedTemplatesCardLineContainer {\n    display: inline-flex;\n    max-height: 2px;\n    width: 100%;\n}\n\n.selectedTemplatesCardLoadingDisplay {\n    display: flex;\n    margin-left: auto;\n    margin-right: auto;\n    max-width: 20em;\n}\n\n.selectedTemplatesCardImageAndTitle {\n    height: 15em;\n    max-height: 15em;\n}\n\n.selectedTemplatesCardImageDisplay {\n    display: inline-block;\n    max-height: 15em;\n    max-width: 20em;\n    margin-left: auto;\n    margin-right: auto;\n    border-radius: 5px;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
